import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enPrivacyPolicyTranslations from "./PrivacyPolicy.en.json";
import arPrivacyPolicyTranslations from "./PrivacyPolicy.ar.json";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    translation: {
      activitySectionTitle: "Activity",
      upcomingOrderButtons: "Upcoming",
      previousOrderButtons: "Previous",
      singleActivityCompanyCard: "Company",
      singleActivityStatusCard: "Status",
      singleActivityCategoryCard: "Category",
      singleActivityPageSnapShotsTitle: "Snapshots from our guests",
      SingelActivityPageRatingAndReviewTitle: "Ratings & Reviews ",
      OrderRegistrationPageTitle: "Registration",
      OrderBookingPageTitle: "Booking",
      OrderPaymentPageTitle: "Payment",
      OrderPageTitle: "Booking Information",
      NextButtonText: "Next",
      OrderButtonText: "ORDER",
      ReORderButtonText: "REORDER",
      CancelButtonText: "CANCEL",
      OrderButtonMessage: "10 people have booked today",
      NumberOfTickets: "Number of tickets",
      AgreeToTermsAndConditions: "Agree to Terms & Conditions",
      Total: "Total",
      PaymentMethods: "Payment Methods",
      CashOnDelivery: "Cash on delivery",
      card: "Online Payment – using a bank card or Apple Pay",
      VisaOrMasterCard: "Online Payment – using a bank card or Apple Pay",
      ApplePay: "Apple Pay",
      Coupon: "Coupon",
      AddCoupon: "Add Coupon",
      ApplyButtonText: "APPLY",
      PayNow: "PAY NOW",
      SuccessMessageTitle: "SUCCESS",
      SuccessMessage: "Congratulations, your order was successfully completed",
      Done: "Done",
      LogoutTitle: "Logout",
      LogoutButtonTitle: "Log out",
      LoginAsCustomer: "Login as Customer",
      PhoneNumber: "Phone Number",
      Password: "Password",
      Login: "Login",
      DontHaveAnAcount: "Don't have an account",
      Registration: "Registration",
      CancelMessage: "This order has been canceled",
      CancelTitle: "CANCELED",
      ConfirmCancelMessage: "Are you sure you want to cancel this order?",
      Confirm: "Confirm",
      FailedToCancelMessage: "Failed to cancel this Order",
      FailedMessageTitle: "Failed",
      Language: "Language",
      English: "English",
      Arabic: "Arabic",
      SAR: "SAR",
      TicketsLeft: "Tickets left",
      perTicket: "Per Ticket",
      Loading: "Loading",
      OrderPageErrorMessage: "An error occurred while fetching your orders!",
      ExploreEvents: "Explore Events",
      SeeUpcomingEvents: "See all upcoming events",
      Available: "Available",
      NoUpcomingYet: "There is no upcoming events available",
      NoPreviousYet: "There is no previous events available",
      ExploreUpcomingEvents: "Explore Upcoming Events",
      Male: "Male",
      Female: "Female",
      PreferNotToSay: "prefer not to say",
      Age: "Age",
      Gender: "Gender",
      Email: "Email",
      DateOfBirth: "Date of Birth",
      NationalID: "National ID/Passport",
      EmailConfirmation: "Email Confirmation",
      Country: "Country",
      FullNameIsRequired: "Full Name is required",
      CountryIsRequired: "Country is required",
      CityIsRequired: "City is required",
      AgeIsRequired: "Age is required",
      GenderIsRequired: "Gender is required ",
      EmailIsRequired: "Email is required",
      EmailConfirmationIsRequired: "Email Confirmation is required",
      EmailDoNotMatch: "Emails do not match",
      SeeMore: "See More",
      SeeLess: "See Less",
      Category: "Category",
      Categories: "Categories",
      SpecialOffers: "Special offers",
      hi: "Hi",
      TrendingActivitiesNearby: "Trending Activities Nearby",
      Explore: "Explore",
      Cities: "Cities",
      Search: "Search",
      TopCities: "Top Cities",
      NoResultsFound: "No Results Found",
      UploadImage: "Upload Image",
      Upload: "UPLOAD ",
      Ratings: "Ratings",
      AddNotesAndComments: "Add Notes and Comments",
      WriteItHere: "Write it here",
      Send: "Send",
      Sending: "Sending",
      Popular: "Popular",
      Edit: "Edit",
      SeeAll: "See All",
      RatingAndReviews: "Ratings & Reviews",
      Reviews: "Reviews",
      BoardingScreen1Title: "Discover Exciting Adventures",
      BoardingScreen1Subtitle:
        "Explore a wide range of activities, from concerts to outdoor adventures, and make the most of your time in Saudi Arabia.",
      BoardingScreen2Title: "Plan Your Next Experience",
      BoardingScreen2SubTitle:
        "Easily browse and book experiences, track your reservations, and get ready for unforgettable moments.",
      BoardingScreen3Title: "Join the Fun",
      SignUp: "Sign Up",
      Next: "Next",
      Skip: "Skip",
      ContinueAsGuest: "Continue as guest",
      MyFavourite: "My Favourite ",
      MyAccount: "My Account",
      SaveChanges: "Save Changes",
      DontRememberYourpassword: "Do not remember your password",
      ForgetPassword: "Forget Password",
      AM: "AM",
      PM: "PM",
      NationalIDIsRequired: "National ID is required",
      City: "City",
      ResetPassword: "Reset Password",
      Home: "Home",
      Orders: "Orders",
      Profile: "Profile",
      Receipt: "Receipt",
      SendOtp: "SEND OTP",
      verifyOtp: "Verify OTP",
      resendOtp: "RESEND OTP",
      PleaseEnterTheOtpSentTo: "Please enter the OTP sent to",
      ReEnterPassword: "Re-Enter Password",
      CreatePassword: "Create Password",
      Submit: "Submit",
      EnterYourPassword: "Enter your password",
      EnterYourPasswordAgain: "Enter your password again",
      Register: "Register",
      LastName: "Last Name",
      AlreadyHaveAccount: "Already Have An Account",
      EnterYourEmail: "Enter your email",
      FirstName: "First Name",
      ChangeProfilePicture: "Change your profile picture",
      ChangePassword: "Change Password",
      CurrentPassword: "Current Password",
      NewPassword: "New Password",
      ConfirmNewPassword: "Confirm New Password",
      WhatsappSupport: "Whatsapp Support",
      EmailSupport: "Email Support",
      PrivacyAndUsagePolicy: "Privacy Policy and Terms of Use",
      policyAcceptanceError: "You must accept the Privacy and Usage Policy.",
      invalidEmailError: "Please enter a valid email address",
      ...enPrivacyPolicyTranslations,
      PaymentFailed: "Payment Failed",
      TryAgain: "Try Again",
      PaymentSuccess: "Your Payment Was Successful",
      LoadMore: "Load More",
      AllResultsLoaded: "All results loaded",
      ErrorFetchingCities: "Error loading cities. Please try again.",
      ErrorFetchingEvents: "Error loading events. Please try again.",
      EventExpiredError: "This time slot has expired. Please select another event.",
      EventExpiredTitle: "Time Slot Expired",
    },
  },
  ar: {
    translation: {
      activitySectionTitle: "نشاطات",
      upcomingOrderButtons: "القادم",
      previousOrderButtons: "السابق",
      singleActivityCompanyCard: "الشركه",
      singleActivityStatusCard: "الحاله",
      singleActivityCategoryCard: "النوع",
      singleActivityPageSnapShotsTitle: "لقطات من ضيوفنا",
      SingelActivityPageRatingAndReviewTitle: "التقييمات والمراجعات ",
      OrderRegistrationPageTitle: "التسجيل",
      OrderBookingPageTitle: "الحجز",
      OrderPaymentPageTitle: "الدفع",
      OrderPageTitle: "معلومات الحجز",
      NextButtonText: "التالي",
      OrderButtonText: "اطلب",
      ReORderButtonText: "إعادة الطلب",
      CancelButtonText: "إلغاء",
      OrderButtonMessage: "10 أشخاص قاموا بالحجز اليوم",
      NumberOfTickets: "عدد التذاكر",
      AgreeToTermsAndConditions: "الموافقة على الشروط والأحكام",
      Total: "الإجمالي",
      PaymentMethods: "طرق الدفع",
      CashOnDelivery: "الدفع عند الاستلام",
      card: "الدفع الإلكتروني – باستخدام البطاقة البنكية أو أبل باي",
      VisaOrMasterCard: "الدفع الإلكتروني – باستخدام البطاقة البنكية أو أبل باي",
      ApplePay: "أبل باي",
      Coupon: "قسيمة",
      AddCoupon: "أضف قسيمة",
      ApplyButtonText: "تطبيق",
      PayNow: "ادفع الآن",
      SuccessMessageTitle: "نجاح",
      SuccessMessage: "تهانينا، تم إكمال طلبك بنجاح",
      Done: "تم",
      LogoutTitle: "تسجيل الخروج ",
      LogoutButtonTitle: "تسجيل الخروج",
      LoginAsCustomer: "تسجيل الدخول كعميل",
      PhoneNumber: "رقم الهاتف",
      Password: "كلمة المرور",
      Login: "تسجيل الدخول",
      DontHaveAnAcount: "ليس لديك حساب؟",
      Registration: "التسجيل",
      CancelMessage: "تم إلغاء هذا الطلب",
      CancelTitle: "إلغاء",
      ConfirmCancelMessage: "هل أنت متأكد أنك تريد إلغاء هذا الطلب؟",
      Confirm: "تأكيد",
      FailedToCancelMessage: "فشل في إلغاء هذا الطلب",
      FailedMessageTitle: "فشل",
      Language: "اللغة",
      English: "الإنجليزية",
      Arabic: "العربية",
      SAR: "ر.س",
      TicketsLeft: "التذاكر المتبقية",
      perTicket: "للتذكره",
      Loading: "جارٍ التحميل",
      OrderPageErrorMessage: "حدث خطأ أثناء جلب طلباتك!",
      ExploreEvents: "استكشاف الفعاليات",
      SeeUpcomingEvents: "عرض جميع الفعاليات القادمة",
      Available: "متاح",
      NoUpcomingYet: "لا يوجد حدث قادم متاح",
      NoPreviousYet: "لا يوجد حدث سابق متاح",
      ExploreUpcomingEvents: "استكشاف الأحداث القادمة",
      Male: "ذكر",
      Female: "أنثى",
      PreferNotToSay: "أفضل عدم الإفصاح",
      Age: "العمر",
      Gender: "الجنس",
      Email: "البريد الإلكتروني",
      DateOfBirth: "تاريخ الميلاد",
      NationalID: "رقم الهوية/جواز السفر",
      EmailConfirmation: "تأكيد البريد الإلكتروني",
      Country: "البلد",
      FullNameIsRequired: "الاسم الكامل مطلوب",
      CountryIsRequired: "البلد مطلوب",
      CityIsRequired: "المدينة مطلوبة",
      AgeIsRequired: "العمر مطلوب",
      GenderIsRequired: "النوع مطلوب",
      EmailIsRequired: "البريد الإلكتروني مطلوب",
      EmailConfirmationIsRequired: "تأكيد البريد الإلكتروني مطلوب",
      EmailDoNotMatch: "البريد الإلكتروني غير متطابق",
      SeeMore: "عرض المزيد",
      SeeLess: "عرض أقل",
      Category: "الفئة",
      Categories: "الفئات",
      SpecialOffers: "عروض خاصة",
      Hi: "مرحبًا",
      TrendingActivitiesNearby: "أنشطة رائجة بالقرب منك!",
      Explore: "استكشف",
      Cities: "المدن",
      Search: "ابحث",
      TopCities: "اشهر المدن",
      NoResultsFound: "لم يتم العثور على نتائج",
      UploadImage: "تحميل صورة",
      Upload: "تحميل",
      Ratings: "التقييمات",
      AddNotesAndComments: "أضف ملاحظات وتعليقات",
      Send: "إرسال",
      Sending: "جارٍ الإرسال",
      WriteItHere: "اكتب هنا",
      Popular: "الاشهر",
      SeeAll: "عرض الكل",
      RatingAndReviews: "التقييمات والمراجعات",
      Reviews: "المراجعات",
      BoardingScreen1Title: "اكتشف مغامرات شيقة",
      BoardingScreen1Subtitle:
        "ستمتع بفعاليات متنوعة في جميع أنحاء المملكة العربية السعودية",
      BoardingScreen2Title: "خطط لتجربتك القادمة",
      BoardingScreen2Subtitle:
        "تصفح واحجز الفعاليات بسهولة، تابع حجوزاتك، واستعد لأوقات لا تُنسى",
      BoardingScreen3Title: "انضم إلى المغامرة",
      SignUp: "انشاء حساب",
      Next: "التالي",
      Skip: "تخطي",
      ContinueAsGuest: "المتابعة كضيف",
      MyFavourite: "المفضل",
      MyAccount: "حسابي",
      SaveChanges: "احفظ التغيرات",
      DontRememberYourpassword: "لا تتذكر كلمة المرور",
      ForgetPassword: "نسيت كلمة المرور",
      AM: "ص",
      PM: "م",
      NationalIDIsRequired: "رقم الهويه مطلوب",
      City: "المدينه",
      ResetPassword: "استرجاع كلمة المرور",
      Home: "الرئيسيه",
      Orders: "الطلبات",
      Profile: "حسابي",
      Receipt: "الوصل",
      SendOtp: "إرسال رمز التحقق",
      verifyOtp: "تحقق من الرمز",
      resendOtp: "إعادة إرسال الرمز",
      PleaseEnterTheOtpSentTo: "يرجى إدخال رمز التحقق المرسل إلى",
      ReEnterPassword: "أعد إدخال كلمة المرور",
      CreatePassword: "إنشاء كلمة مرور",
      Submit: "إرسال",
      EnterYourPassword: "أدخل كلمة المرور الخاصة بك",
      EnterYourPasswordAgain: "أدخل كلمة المرور مرة أخرى",
      Register: "تسجيل",
      LastName: "اللقب",
      AlreadyHaveAccount: "هل لديك حساب بالفعل",
      EnterYourEmail: "أدخل بريدك الإلكتروني",
      FirstName: "الاسم الاول",
      ChangeProfilePicture: "تغيير الصوره الشخصيه ",
      ChangePassword: "تفير كلمة المرور",
      CurrentPassword: "كلمة المرور الحالية",
      NewPassword: "كلمة المرور الجديدة",
      ConfirmNewPassword: "تأكيد كلمة المرور الجديده",
      WhatsappSupport: "الدعم عبر الواتساب",
      EmailSupport: "الدعم عبر البريد الإلكتروني",
      PrivacyAndUsagePolicy: "سياسة الخصوصية و شروط الاستخدام",
      policyAcceptanceError: "يجب عليك قبول سياسة الخصوصية و شروط الاستخدام.",
      invalidEmailError: "الرجاء إدخال عنوان بريد إلكتروني صالح",
      ...arPrivacyPolicyTranslations,
      PaymentFailed: "عمليه مرفوضه",
      TryAgain: "حاول مجددا",
      PaymentSuccess: "عملية دفعك تمت بنجاح",
      LoadMore: "تحميل المزيد",
      AllResultsLoaded: "تم تحميل جميع النتائج",
      ErrorFetchingCities: "خطأ في تحميل المدن. يرجى المحاولة مرة أخرى.",
      ErrorFetchingEvents: "خطأ في تحميل الفعاليات. يرجى المحاولة مرة أخرى.",
      EventExpiredError: "انتهت صلاحية هذا الموعد. يرجى اختيار فعالية أخرى.",
      EventExpiredTitle: "انتهت صلاحية الموعد",
    },
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
